export type FileIconDescriptor = { name: string; fallback?: string };

export const resolveFileIcon = ({
  fileName,
  isShortCutFile,
}: {
  fileName?: string;
  isShortCutFile?: boolean;
}): FileIconDescriptor => {
  const ext = fileName?.split(".").pop()?.toUpperCase() ?? "";
  if (!ext) return { name: "files" };
  return isShortCutFile
    ? { name: `filesShortcutIcons/Sfile${ext}`, fallback: "SfileUNKNOWN" }
    : { name: `File${ext}`, fallback: "FileNONE" };
};

export type ResourceIconDescriptor =
  { kind: "name"; name: string } | { kind: "file"; fileName: string; isShortCutFile: boolean };

/** The subset of a file-manager row this resolver reads. */
interface ResourceIconInput {
  resourceType: string;
  permission?: { copy?: boolean; download?: boolean; read?: boolean; upload?: boolean; write?: boolean };
  name: string;
  isContainer?: boolean;
  containerType?: string;
}

export const resolveResourceIcon = ({ file }: { file?: ResourceIconInput }): ResourceIconDescriptor | null => {
  if (!file) return null;
  const { resourceType, permission, name, isContainer, containerType } = file;

  if (resourceType === "RESOURCE_TYPE_FOLDER" || resourceType === "RESOURCE_TYPE_TRANSMITTAL") {
    const locked =
      !permission?.copy && !permission?.download && !permission?.read && !permission?.upload && !permission?.write;
    return { kind: "name", name: locked ? "folderlock" : "folder" };
  }

  const resourceTypeMap: Record<string, string> = {
    RESOURCE_TYPE_SCHEDULE: "schedules",
    RESOURCE_TYPE_ISSUES: "issues",
    RESOURCE_TYPE_TASKS: "tasks",
    RESOURCE_TYPE_CONTRACT: "Contracts",
    RESOURCE_TYPE_EMBED: "embedUrl",
    RESOURCE_TYPE_ESTIMATE: "EstimateIcon",
    RESOURCE_TYPE_MERGED_FILE: "FileMER",
  };
  // `!` because `noUncheckedIndexedAccess` widens the lookup, though the `if` already proved it.
  if (resourceTypeMap[resourceType]) return { kind: "name", name: resourceTypeMap[resourceType]! };

  if (resourceType === "RESOURCE_TYPE_SHORTCUT_MERGED_FILE" || resourceType === "RESOURCE_TYPE_SHORTCUT_FILE") {
    return { kind: "file", fileName: name, isShortCutFile: true };
  }
  if (resourceType === "RESOURCE_TYPE_FILE") {
    if (isContainer && containerType) return { kind: "name", name: `File${containerType.toUpperCase()}` };
    return { kind: "file", fileName: name, isShortCutFile: false };
  }
  return { kind: "name", name: "FileNONE" };
};
